import React, { ComponentType, useState, useEffect, PropsWithChildren } from 'react';

const useIsClient = () => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return isClient;
};

export function clientOnly<P extends {}>(Wrapped: ComponentType<P>): ComponentType<P> {
    return function ClientOnly(props: P) {
        const isClient = useIsClient();

        if (!isClient) {
            return null;
        }

        return <Wrapped {...props} />;
    };
}

// After hydration navigation between pages might occur on the client side
// at the spa transition null fallback doesn't make sense.
// Why can't we aplly this approach to all client only components?
// Because it doesn't work with selective hydration.

let isClientPersistent = false;

export function clientOnlyPage<P extends {}>(Wrapped: ComponentType<P>): ComponentType<P> {
    return function ClientOnly(props: P) {
        const [isClient, setIsClient] = useState(isClientPersistent);

        useEffect(() => {
            setIsClient(true);
            isClientPersistent = true;
        }, []);

        if (!isClient) {
            return null;
        }

        return <Wrapped {...props} />;
    };
}

export function clientOnlyWrapper<P extends PropsWithChildren>(
    Wrapped: ComponentType<P>
): ComponentType<P> {
    return function ClientOnlyLayout(props: P) {
        const [isClient, setIsClient] = useState(isClientPersistent);

        useEffect(() => {
            setIsClient(true);
            isClientPersistent = true;
        }, []);

        if (!isClient) {
            // eslint-disable-next-line react/destructuring-assignment
            return props.children;
        }

        return <Wrapped {...props} />;
    };
}
